export default __webpack_public_path__ + "static/media/doc-admin-view.38e792cf.svg";